<template>
  <div :class="{ conversion: isConversion, default: !isConversion }">
    <div class="runner">チーム名</div>
    <div class="name font-english">NAME</div>
    <div id="js-runner-name" class="runner-name">
      {{ dataRunner.certificate_ranking.company_name }}
    </div>
    <div class="record">
      <div class="item-area">
        <div class="item-ja">{{
          dataRunner.certificate_ranking.ranking_item.ja
        }}</div>
        <div class="item-en font-english">{{
          dataRunner.certificate_ranking.ranking_item.en
        }}</div>
      </div>
      <div class="finish-time">{{ dataRunner.certificate_ranking.result }}</div>
      <div class="item-area">
        <div class="item-ja">{{
          dataRunner.certificate_ranking.ranking_detail.ja
        }}</div>
        <div class="item-en font-english">{{
          dataRunner.certificate_ranking.ranking_detail.en
        }}</div>
      </div>
      <div class="finish-ranking">
        {{ dataRunner.certificate_ranking.ranking }}位&nbsp;<span
          class="participants"
          >/{{ dataRunner.certificate_ranking.ranking_num }}チーム中</span
        >
      </div>
    </div>
    <div class="category">
      <div
        class="item-area"
        v-if="dataRunner.certificate_ranking.completed_num"
      >
        <div class="item-ja">チーム完走者数</div>
        <div class="item-en font-english">NUMBER OF FINISHERS</div>
      </div>
      <div class="item-area" v-else>
        <div class="item-ja">チーム参加者数</div>
        <div class="item-en font-english">NUMBER OF PARTICIPANTS</div>
      </div>
      <div
        class="participants"
        v-if="dataRunner.certificate_ranking.completed_num"
      >
        {{ dataRunner.certificate_ranking.completed_num }}人
      </div>
      <div class="participants" v-else>
        {{ dataRunner.certificate_ranking.member_num }}人
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.certificateWidth === 1000
      ? document
          .getElementById("js-runner-name")
          .classList.remove("multiple-lines-font")
      : document
          .getElementById("js-runner-name")
          .classList.remove("dw-multiple-lines-font");
    const textLength =
      document.getElementById("js-runner-name").innerText.length;

    if (textLength > 20) {
      this.certificateWidth === 1000
        ? document
            .getElementById("js-runner-name")
            .classList.add("multiple-lines-font")
        : document
            .getElementById("js-runner-name")
            .classList.add("dw-multiple-lines-font");
    }
  },
  props: {
    isConversion: Boolean,
    certificateWidth: Number,
    dataRunner: Object,
  },
  name: "TeamRanking",
};
</script>

<style scoped lang="scss">
$certificate-color: #c9ba87;
$sub-certificate-color: #a8985f;
.font-english {
  font-family: "EB Garamond", sans-serif;
}
.default {
  .runner {
    margin: 2.5% 0 0 0;
    font-size: 1.2em;
    font-weight: bold;
    color: $sub-certificate-color;
  }

  .name {
    font-size: 1em;
    color: $sub-certificate-color;
  }

  .runner-name {
    display: inline-flex;
    align-items: center;
    max-width: 73%;
    height: 50px;
    line-height: 1.5;
    border-bottom: 1px solid $certificate-color;
    /*2行になったら1em jsで対応*/
    font-size: 2.2em;
    font-weight: bold;
    overflow: hidden;
  }

  .multiple-lines-font {
    font-size: 1em;
  }

  .record {
    margin: 3.5% 10% 0 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;

    .item-area {
      margin: 0 2.5% 0 0;
      padding: 0 0 0 1.3%;
      border-left: solid 2px $sub-certificate-color;
      color: $sub-certificate-color;

      .item-ja {
        font-size: 1.2em;
        font-weight: bold;
      }

      .item-en {
        font-size: 0.8em;
      }
    }

    .finish-time,
    .finish-ranking {
      font-size: 2em;
      font-weight: bold;

      .participants {
        font-size: 0.5em;
      }
    }
  }

  .category {
    margin: 3.5% 10% 0 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;

    .item-area {
      margin: 0 2.5% 0 0;
      padding: 0 0 0 1.3%;
      color: $sub-certificate-color;

      .item-ja {
        font-size: 1.2em;
        font-weight: bold;
      }

      .item-en {
        font-size: 0.8em;
      }
    }

    .participants {
      font-size: 2em;
      font-weight: bold;
    }
  }
}

/** 4000 */
.conversion {
  .runner {
    margin: 2.5% 0 0 0;
    font-size: 70px;
    font-weight: bold;
    color: $sub-certificate-color;
  }
  .name {
    font-size: 60px;
    color: $sub-certificate-color;
  }
  .runner-name {
    display: inline-flex;
    align-items: center;
    max-width: 3000px;
    height: 240px;
    line-height: 1.5;
    border-bottom: 4px solid $certificate-color;
    /*2行になったら66px jsで対応*/
    font-size: 150px;
    font-weight: bold;
    overflow: hidden;
  }
  .dw-multiple-lines-font {
    font-size: 66px;
  }
  .record {
    margin: 3.5% 13% 0 13%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;

    .item-area {
      margin: 0 2.5% 0 0;
      padding: 0 0 0 1.3%;
      border-left: solid 2px $sub-certificate-color;
      color: $sub-certificate-color;

      .item-ja {
        font-size: 70px;
        font-weight: bold;
      }

      .item-en {
        margin: 10px 0 0 0;
        font-size: 50px;
      }
    }

    .finish-time,
    .finish-ranking {
      font-size: 150px;
      font-weight: bold;

      .participants {
        font-size: 60px;
      }
    }
  }
  .category {
    margin: 3.5% 13% 0 13%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;

    .item-area {
      margin: 0 2.5% 0 0;
      padding: 0 0 0 1.3%;
      border-left: solid 2px $sub-certificate-color;
      color: $sub-certificate-color;

      .item-ja {
        font-size: 70px;
        font-weight: bold;
      }

      .item-en {
        margin: 10px 0 0 0;
        font-size: 50px;
      }
    }

    .participants {
      font-size: 150px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TeamRanking.vue